import type { Tenant, User, UserRole } from '@/type';

import {
  COLLECTION_ROUTE_PATH,
  EXTERNAL_STORAGE_LINK_ROUTE_PATH,
} from './collectionConstant';

export enum LANG {
  KO = 'ko',
  EN = 'en',
  CN = 'cn',
  JP = 'jp',
}

export const LANGUAGE_LIST = [
  {
    i18nKey: 'app.language.ko',
    value: LANG.KO,
  },
  {
    i18nKey: 'app.language.en',
    value: LANG.EN,
  },
  {
    i18nKey: 'app.language.cn',
    value: LANG.CN,
  },
  {
    i18nKey: 'app.language.jp',
    value: LANG.JP,
  },
];

export const KEYS = {
  STORAGE_LANG: 'STORAGE_LANG',
  STORAGE_REDIRECT_URL: 'STORAGE_REDIRECT_URL',
  STORAGE_IDB_STORE_LIST: 'STORAGE_IDB_STORE_LIST',
} as const;

export const DEFAULT_REDIRECT_PATH = '/project';
export const DEFAULT_WORKER_REDIRECT_PATH = '/my-work';
export const GET_REDIRECT_PATH_BY_ROLE = (role: User['role']) =>
  role === 'Worker' ? DEFAULT_WORKER_REDIRECT_PATH : DEFAULT_REDIRECT_PATH;

export const ROLE_NON_ACCESS_ROUTES_MAPPER: {
  [K in UserRole]: (string | RegExp)[];
} = {
  Owner: [],
  Admin: [],
  SiteAdmin: [],
  Manager: [],
  Worker: [
    COLLECTION_ROUTE_PATH,
    EXTERNAL_STORAGE_LINK_ROUTE_PATH,
    '/project',
    '/modeling',
    '/deployment',
    '/api-key',
    '/admin-setting',
  ],
  Guest: [
    COLLECTION_ROUTE_PATH,
    EXTERNAL_STORAGE_LINK_ROUTE_PATH,
    '/project',
    '/modeling',
    '/deployment',
    '/api-key',
    '/admin-setting',
  ],
};

export const APP_API_URL = import.meta.env.VITE_APP_API_URL;

export const PRICE_PLAN_PER_TENANT: {
  [key in Tenant['tier']]: {
    autoLableing: number; // frame
    dataStorage: number; //GB
    member: {
      admin: number;
      member: number;
    };
    ec2: string;
    maxUploadSize: number; // MB
  };
} = {
  freetier: {
    autoLableing: 100,
    dataStorage: 10,
    member: {
      admin: 1,
      member: 1,
    },
    ec2: 'g4dn.xlarge',
    maxUploadSize: 5,
  },
  standard: {
    autoLableing: 2000,
    dataStorage: 150,
    member: {
      admin: 1,
      member: 1,
    },
    ec2: 'g4dn.2xlarge',
    maxUploadSize: 5,
  },
};
